(ns app.front.view.admin.domain-groups.municipality-groups
  (:require [app.domain.group.model :as group-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.ui.top-bar :as top-bar]
            [app.front.util :as futil :refer [for-all for-frag]]
            [app.front.view.admin.common :as admin-common]
            [app.front.view.admin.domain-groups.common :as domain-groups-common]
            [app.front.view.admin.domain-groups.municipality-categories :as municipality-categories]
            [app.front.view.admin.domain-groups.municipality-list :as municipality-list]
            [app.front.view.admin.domain-groups.subs :as domain-groups-subs]
            [app.front.view.admin.subs :as admin-subs]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.domain.validators :as v]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.i18n :as i18n]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-chain.core :as rc]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-event-fx ::fetch-countries-and-merge-groups
  (fn [{:keys [db]} [_ status response]]
    {:db         (assoc db
                        ::categories (:categories response)
                        ::countries (:countries response)
                        ::timezones (:timezones response)
                        ::currencies (:currencies response))
     :dispatch-n [[::entities/merge-entity-db status (:entities response)]
                  [::domain-groups-subs/fetch-municipalities-public]
                  [::loading-done]]}))


(rf/reg-event-db ::loading-done
  (fn [db _]
    (dissoc db ::groups-loading?)))


(rf/reg-event-fx ::fetch-municipalities
  (fn [{:keys [db]} _]
    {:comm/command {:command    :admin/municipality-groups
                    :method     :get
                    :on-success [::fetch-countries-and-merge-groups]}
     :db           (assoc db ::groups-loading? true)}))


(rf/reg-event-fx ::fetch-mobile-app-safe-group-ids
  (fn [_ _]
    {:comm/command {:command    :admin/mobile-app-safe-groups
                    :method     :get
                    :on-success [::fetch-mobile-app-safe-group-ids.success]}}))

(rf/reg-event-db ::fetch-mobile-app-safe-group-ids.success
  (fn [db [_ _ ids]]
    (assoc db ::mobile-app-safe-group-ids ids)))


(rf/reg-event-fx ::get-group-configs
  (fn [_ [_ id]]
    {:comm/command {:command    :admin/group-configs
                    :method     :get
                    :data       {:domain-group-id id}
                    :on-success [::get-group-configs.success]}}))


(rf/reg-event-fx ::get-group-configs.success
  (fn [_ [_ _ group-configs]]
    (let [enabled-categories (->> group-configs
                                  (filter #(-> % :group.config/level (= :group-config.level/permit-type)))
                                  (reduce (fn [acc root-group-config]
                                            (->> group-configs
                                                 ;; Note, these are not Entities, just maps
                                                 (filter #(and (-> % :entity/parent (= (:db/id root-group-config)))
                                                               (-> %
                                                                   :domain/state
                                                                   (not= :group-config.state/hidden))))
                                                 (keep :group.config/target)
                                                 set
                                                 (assoc acc (:group.config/target root-group-config))))
                                          {}))]
      {:fx [[:dispatch-n [[::admin-subs/dialog-edit :new-municipality :categories enabled-categories]
                          [::admin-subs/dialog-edit :new-municipality :saved-categories enabled-categories]
                          [::admin-subs/dialog-edit :new-municipality :disabled? false]]]]})))


(rf/reg-event-fx ::toggle-feature
  (fn [_ [_ group-id feature features enabled? group-version]]
    ;; We update the entity-db immediately in order to avoid irritating UI lag.
    {:dispatch     [::entities/update-entity group-id
                    {:group/features ((if enabled? conj disj)
                                      (or features #{})
                                      feature)}]
     :comm/command {:command          :admin/toggle-group-feature
                    :data             {:group-id       group-id
                                       :feature        feature
                                       :enabled?       enabled?
                                       :entity/version group-version}
                    :on-success       [::entities/apply-changes]
                    :finally-dispatch [::toggle-feature.done group-id feature features enabled?]
                    :notify           {:success :changes-saved}}}))


(rf/reg-event-fx ::toggle-feature.done
  (fn [_ [_ group-id feature features enabled? status]]
    (when (not= status 200)
      ;; Cancel eagerly checked box
      {:dispatch [::entities/update-entity group-id
                  {:group/features ((if enabled? disj conj)
                                    features
                                    feature)}]})))


(rf/reg-sub ::lower-tier-authority-groups
  :<- [::entities/context]
  (fn [ctx _]
    (entities/find-entities ctx {:group/type :group.type/application-authority})))


(rf/reg-sub ::lower-tier-domain-groups
  :<- [::lower-tier-authority-groups]
  (fn [authority-groups _]
    (->> authority-groups
         (map :entity/parent)
         (filter :group/name)
         distinct
         (sort-by :group/name))))


(rf/reg-sub ::lower-tier-planning-groups
  :<- [::entities/entities {:group/type :group.type/application-authority}]
  (fn [ags _]
    (->> ags
         (filter #(contains? (group-model/get-permit-types %) :permit-type/P))
         distinct
         (sort-by :group/name))))

;; --------------------------
;; Dialog events ands subs
;; --------------------------


(rf/reg-sub ::countries :-> ::countries)

(rf/reg-sub ::timezones :-> ::timezones)

(rf/reg-sub ::currencies :-> ::currencies)

(rf/reg-sub ::groups-loading? :-> ::groups-loading?)

(rf/reg-sub ::mobile-app-safe-group-ids :-> ::mobile-app-safe-group-ids)

(rf/reg-event-fx
  ::dialog-save.done
  (fn [_ [_ k]]
    {:dispatch-n [[::admin-subs/dialog-edit k :disabled? false]]}))


(def edit-save-keys
  [:group-name
   :group-domain
   :group-number
   :timezone
   :currency
   :municipalities
   :categories
   :permit-types])


(defn group-id->group-number [group-id]
  (str/replace group-id #"\w\w-" ""))


(defn edit-command [db id key upper-tier?]
  {:command          :admin/edit-municipality-group
   :data             (-> (:new-municipality db)
                         (select-keys (concat edit-save-keys
                                              [:country-code
                                               :removed-permit-types]
                                              (when upper-tier? [:planning-lower-tier-ids
                                                                 :subdivision
                                                                 :config-languages])))
                         (p/update-if-contains :municipalities
                                               (partial map #(select-keys % [:name :official-name :number :location])))
                         (assoc :id id)
                         municipality-categories/filter-categories-param)
   :finally-dispatch [::dialog-save.done key]})


(defn create-command [db key upper-tier?]
  {:command          :admin/create-municipality-group
   :data             (-> (:new-municipality db)
                         (select-keys (concat edit-save-keys
                                              [:country-code
                                               :skip-default-configuration?
                                               :subdivision
                                               :config-languages]
                                              (when upper-tier? [:planning-lower-tier-ids])))
                         (merge {:group-type (if upper-tier?
                                               :group.type/upper-tier-authority
                                               :group.type/application-authority)})
                         municipality-categories/filter-categories-param)
   :finally-dispatch [::dialog-save.done key]})

(rc/reg-chain ::dialog-save
  (fn [_ [_ k]]
    (>evt [::admin-subs/dialog-edit k :disabled? true]))
  (fn [{:keys [db]} [_ k]]
    (let [upper-tier? (-> db :new-municipality :tier (= :upper-tier))]
      {:comm/command (if-let [id (-> db :new-municipality :edit-group-id)]
                       (edit-command db id k upper-tier?)
                       (create-command db k upper-tier?))}))

  (fn [_ [_ k status {:keys [changes entities]}]]
    (when (seq changes)
      (>evt [::entities/apply-changes status changes]))
    (when (seq entities)
      (>evt [::entities/override-entity-db status entities]))
    (>evt [::fetch-municipalities])
    (>evt [::fetch-mobile-app-safe-group-ids])
    (>evt [::admin-subs/dialog-close k])))


(defn valid-domain? [domain]
  (and (not (str/blank? domain))
       (v/valid-domain? domain)))

(rf/reg-sub ::dialog-filled?
  :<- [::admin-subs/dialogs]
  :<- [::countries]
  :<- [::domain-groups-subs/coordinates]
  (fn [[data countries coords] _]
    (let [{:keys [country-code subdivision timezone permit-types
                  group-name municipalities group-number
                  group-domain edit-group-id tier
                  planning-lower-tier-ids]}                      (:new-municipality data)
          upper-tier?                                            (= tier :upper-tier)
          has-municipalities?                                    (seq municipalities)
          has-permit-types?                                      (seq permit-types)
          has-lower-tiers?                                       (seq planning-lower-tier-ids)
          subdivision-required?                                  (and (seq (get countries country-code))
                                                                      has-municipalities?
                                                                      has-permit-types?)]
      (and (not (str/blank? group-name))
           (or (some? edit-group-id)
               (workspace-model/group-number? group-number))
           (some? timezone)
           (some? country-code)
           (or (not subdivision-required?)
               (some? subdivision))
           (valid-domain? group-domain)
           (or (and upper-tier?
                    has-lower-tiers?
                    (not has-permit-types?)
                    (not has-municipalities?))
               (and has-permit-types?
                    has-municipalities?
                    (every? (partial domain-groups-common/valid-municipality? coords) municipalities)
                    ;; no duplicate municipality numbers
                    (domain-groups-common/municipality-numbers-unique? municipalities)))))))


(rf/reg-sub ::domain-valid?
  :<- [::admin-subs/dialog-data :new-municipality]
  (fn [dialog-data]
    (if-let [domain (:municipality-domain dialog-data)]
      (v/valid-domain? domain)
      true)))


;; --------------------------------
;; Approver group events and subs
;; --------------------------------


(rf/reg-event-fx ::new-municipality-open
  (fn [{:keys [db]} [_ tier]]
    (let [country-code (-> db ::countries keys first)]
      {:dispatch-n [[::admin-subs/dialog-open
                     :new-municipality
                     (cond-> {:country-code     country-code
                              :currency         (-> db ::currencies first)
                              :permit-types     #{}
                              :categories       (ptc-model/filter-default-category-map
                                                  (::categories db))
                              :modal-title-key  :admin/new-municipality
                              :config-languages #{i18n-model/default-lang}
                              :tier             tier}
                       (= tier :upper-tier) (assoc :planning-lower-tier-ids #{}))]
                    [::municipality-categories/toggle-current-list nil]]})))

(defn active-permit-types [authority-groups]
  (->> authority-groups
       (mapcat group-model/permit-type-configs)
       (remove :permit-type-config/hidden?)
       (keep :permit-type-config/permit-type)
       set))


(defn pending-config-permit-types [authority-groups]
  (let [active-permit-types (active-permit-types authority-groups)]
    (->> authority-groups
         (mapcat (fn [authority-group]
                   (let [configured-permit-types (->> (group-model/permit-type-configs authority-group)
                                                      (keep :permit-type-config/permit-type)
                                                      set)]
                     (set/difference (group-model/get-scope-permit-types authority-group)
                                     configured-permit-types
                                     active-permit-types))))
         set)))

(defn editable-municipality [{{:location.center/keys [x y]} :municipality/center-location
                              :municipality/keys            [names official-names number]
                              :as                           municipality}]
  (merge
    {:db/id         (:db/id municipality)
     :name          (i18n-model/strings-map names)
     :official-name (i18n-model/strings-map official-names)
     :number        number}
    (when (and x y)
      {:location [x y]})))

(rf/reg-event-fx ::edit-municipality-open
  (fn [{:keys [db]} [_ domain-group tier lower-tier-groups]]
    (let [authority-groups (-> domain-group
                               :entity/_parent)
          municipalities   (->> authority-groups
                                (mapcat group-model/scope-municipalities)
                                distinct)
          countries        (::countries db)
          subdivision      (or (:domain/subdivision domain-group)
                               (-> municipalities first :municipality/subdivision))
          country-code     (or (-> municipalities first :municipality/country)
                               ;; If an upper-tier has been saved without municipalities (because it can), the country is not known.
                               ;; Then deduce it from subdivision.
                               (-> countries
                                   (p/find-first
                                     (fn [[_ subdivisions]] (-> subdivisions set (contains? subdivision))))
                                   first)
                               ;; Or take default.
                               (-> countries keys first))
          default-data     {:permit-types                (active-permit-types authority-groups)
                            :pending-config-permit-types (pending-config-permit-types authority-groups)
                            :group-name                  (:group/name domain-group)
                            :country-code                country-code
                            :subdivision                 subdivision
                            :original-subdivision        (-> municipalities first :municipality/subdivision)
                            :timezone                    (:group/tz domain-group)
                            :municipality-number         (->> municipalities
                                                              (map :municipality/number)
                                                              (str/join "; "))
                            :group-number                (group-id->group-number (:group/id domain-group))
                            :group-domain                (:group/domain domain-group)
                            :edit-group-id               (:db/id domain-group)
                            :modal-title-key             :admin/edit-municipality
                            :currency                    (:group/currency domain-group)
                            :municipalities              (->> municipalities
                                                              (map editable-municipality))
                            :tier                        tier
                            :planning-lower-tier-ids     (or lower-tier-groups #{})
                            ;; Dialog is disabled until group config fetch finishes
                            :disabled?                   true}]
      {:dispatch-n [[::admin-subs/dialog-open :new-municipality default-data]
                    [::municipality-categories/toggle-current-list nil]
                    [::get-group-configs (:group/id domain-group)]]})))


(rc/reg-chain ::rename-group
  (fn [_ [_ group-id new-name]]
    {:comm/command {:command :admin/rename-group
                    :data    {:group-id group-id
                              :new-name new-name}}})
  (fn [_ [_ group-id new-name]]
    (>evt [::entities/update-entity group-id {:group/name new-name}])))


(rf/reg-event-fx ::geocode-if-enough-data
  (fn [{:keys [db]} _]
    (let [{:keys [group-name subdivision country-code group-number]} (:new-municipality db)
          no-subdivs?                                                (empty? (get-in db [::countries country-code]))]
      (when (and (str/blank? group-number)
                 (string? group-name)
                 (>= (count group-name) 5)
                 (or subdivision
                     no-subdivs?)
                 country-code)
        {:dispatch-debounce {:id      ::request-geocoding
                             :timeout 300
                             :action  :dispatch
                             :event   [::domain-groups-subs/do-geocoding-request
                                       (p/assoc-if {:search-text group-name
                                                    :country     country-code}
                                                   :subdivision subdivision)
                                       [::geocoding-request.success]]}}))))


(rf/reg-event-db ::geocoding-request.success
  (fn [db [_ _ {:keys [coordinates municipality-number timezone]}]]
    (cond-> db
      (-> db :new-municipality :group-number str/blank?)
      (assoc-in [:new-municipality :group-number] municipality-number)

      (-> db :new-municipality :timezone str/blank?)
      (assoc-in [:new-municipality :timezone] timezone)

      (-> db (get-in [::domain-groups-subs/coordinates municipality-number]) str/blank?)
      (assoc-in [::domain-groups-subs/coordinates municipality-number] coordinates))))


(rf/reg-event-fx ::disable-domain-group
  (fn [_ [_ group-id]]
    {:dispatch [:comm/command-monitored {:command    :admin/disable-domain-group
                                         :data       {:group-id group-id}
                                         :on-success [::entities/apply-changes]
                                         :notify     {:success :admin/deactivate-group-success}}]}))


;; --------------------------
;; Dialogs and modal bodies
;; --------------------------


(defn- dialog
  "Dialog with Cancel and Save buttons. The actual contents (modal body)
  is given via arguments."
  [{:keys [tr] :as options} {:keys [key focus-selector body]}]
  (let [open?     (boolean (<sub [::admin-subs/dialog-data key :open?]))
        disabled? (boolean (<sub [::admin-subs/dialog-data key :disabled?]))
        title-key (<sub [::admin-subs/dialog-data key :modal-title-key])
        cancel-fn #(>evt [::admin-subs/dialog-close key])]
    [ui-modal/composed-input-modal
     {:open                   open?
      :selector-primary-focus focus-selector
      :on-close               cancel-fn}
     (cc/modal-header
       {:close-modal cancel-fn
        :title       (tr [title-key])}
       (when disabled?
         (cc/inline-loading {:description (tr [:loading])})))

     (when open?
       (cc/modal-body {} [body options]))
     (cc/modal-footer
       {}
       (cc/button
         {:kind     :secondary
          :disabled disabled?
          :on-click cancel-fn}
         (tr [:cancel]))
       (cc/button
         {:kind     :primary
          :disabled (or disabled?
                        (not (<sub [::dialog-filled?])))
          :on-click #(>evt [::dialog-save key])}
         (tr [:save])))]))


(def input-block :div.bx--row.mt-2>div.bx--col-xs-12)

(def select-input-block :div.bx--row.mt-2>div.bx--col-xs-12.bx--col-sm-6)

(defn <sub-dialog-data [k]
  (<sub [::admin-subs/dialog-data :new-municipality k]))


(defn group-info-inputs [{:keys [tr disabled? editing? edit-fn]}]
  (let [countries  (<sub [::countries])
        timezones  (<sub [::timezones])
        currencies (<sub [::currencies])]
    [:<>
     [select-input-block
      (cc/select
        {:id         "country-code"
         :class-name "full-width-select"
         :label-text (tr [:admin/country-code])
         :on-change  #(do (>evt [::admin-subs/dialog-edit
                                 :new-municipality
                                 :country-code
                                 (-> % .-target .-value keyword)])
                          (>evt [::geocode-if-enough-data]))
         :disabled   (or disabled? editing?)
         :required   true
         :value      (<sub-dialog-data :country-code)}
        (for-frag [[country-code _] countries]
          (cc/select-item {:text  (tr [(keyword "country" (name country-code))])
                           :value country-code})))]
     [select-input-block
      (cc/select
        {:id         "currency"
         :class-name "full-width-select"
         :label-text (tr [:admin/currency])
         :value      (<sub-dialog-data :currency)
         :on-change  (edit-fn :currency)
         :disabled   disabled?
         :required   true}
        (for-frag [tz currencies]
          (cc/select-item {:text  tz
                           :value tz})))]
     (when-let [subdivisions (seq (get countries (<sub-dialog-data :country-code)))]
       [select-input-block
        [ui-select/select
         {:id           "subdivision"
          :class-name   "full-width-select"
          :label-text   (tr [:admin/subdivision])
          :on-change    #(do (>evt [::admin-subs/dialog-edit
                                    :new-municipality
                                    :subdivision
                                    %])
                             (>evt [::geocode-if-enough-data]))
          ;; Need to allow setting the subdivision if editing a municipality-less group (an upper-tier may be one)
          :disabled     (-> (or disabled?
                                (<sub-dialog-data :original-subdivision))
                            boolean)
          :required     (boolean (seq (<sub-dialog-data :municipalities)))
          :values       subdivisions
          :val->str     #(tr [(keyword "subdivision" (name %))])
          :value        (<sub-dialog-data :subdivision)
          :allow-empty? false
          :select-text  (tr [:none])}]])

     [select-input-block
      (cc/select
        {:id         "timezone"
         :class-name "full-width-select"
         :label-text (tr [:admin/timezone])
         :value      (or (<sub-dialog-data :timezone)
                         :none)
         :on-change  (edit-fn :timezone)
         :disabled   disabled?
         :required   true}
        [ui/placeholder-select-item tr]
        (for-frag [tz timezones]
          (cc/select-item {:text  tz
                           :value tz})))]]))

(defn new-multi-municipality-modal-body [{:keys [edit-fn tr disabled? editing?] :as opts}]
  (r/with-let [*editing-group-number? (r/atom false)]
    (let [upper-tier? (= (<sub-dialog-data :tier) :upper-tier)]
      [:div.w-full
       {:id "new-municipality-group-modal"}
       [:<>
        [input-block
         [ui/text-input {:id            "group-name"
                         :label-text    (tr [:admin/group-name])
                         :placeholder   (tr [:placeholder/group])
                         :disabled      disabled?
                         :on-change     (fn [e]
                                          ((edit-fn :group-name) e)
                                          (>evt [::geocode-if-enough-data]))
                         :default-value (<sub-dialog-data :group-name)}]]

        [group-info-inputs (util/mmap tr disabled? editing? edit-fn)]

        [:div.bx--row.mt-2
         [:div.bx--col-xs-12
          [ui/text-input {:key           "group-number"
                          :id            "group-number"
                          :label-text    (tr [:admin/group-id])
                          :placeholder   (tr [:placeholder/municipality-code])
                          :pattern       workspace-model/group-number-pattern
                          :disabled      (or disabled? (and editing? (not @*editing-group-number?)))
                          :default-value (<sub-dialog-data :group-number)
                          :on-change     (edit-fn :group-number)}]]
         (if @*editing-group-number?
           [:div.bx--col-xs-12.mt-2
            [:span.font-bold.text-ui-red.pr-2 (tr [:admin/edit-group-number-confirmation])]]
           (when editing?
             [:div.bx--col-xs-12.mt-2
              (cc/button
                {:kind     :danger
                 :icon     i/warning
                 :on-click (fn [_] (reset! *editing-group-number? true))}
                (tr [:edit]))]))]

        [input-block
         [ui/text-input {:id            "group-domain"
                         :label-text    (tr [:admin/group-domain-label])
                         :placeholder   (tr [:admin/placeholder-domain])
                         :disabled      disabled?
                         :invalid       (not (<sub [::domain-valid?]))
                         :invalid-text  (tr [:admin/invalid-domain])
                         :default-value (<sub-dialog-data :group-domain)
                         :on-change     (edit-fn :group-domain)}]]

        (when-not editing?
          [input-block
           (let [selected-languages (<sub-dialog-data :config-languages)
                 locales            (<sub [::i18n/locales])]
             (when (seq locales)
               [:<>
                [:div.bx--label (tr [:admin/languages-for-permit-types])]
                [:div.flex
                 (for-frag [[locale names] locales]
                   [:div.mr-6
                    (cc/checkbox {:id         (str "group-config-languages-" (name locale))
                                  :label-text (:name names)
                                  :checked    (contains? selected-languages locale)
                                  ;; at least one language must be selected
                                  :disabled   (= (set selected-languages) #{locale})
                                  :on-change  #(>evt [::admin-subs/dialog-edit
                                                      :new-municipality
                                                      :config-languages
                                                      ((if % conj disj)
                                                       (set selected-languages)
                                                       locale)])})])]]))])

        [input-block
         (if-let [categories (<sub-dialog-data :categories)]
           [municipality-categories/permit-type-list
            (merge opts
                   {:permit-types                (<sub-dialog-data :permit-types)
                    :removed-permit-types        (<sub-dialog-data :removed-permit-types)
                    :pending-config-permit-types (<sub-dialog-data :pending-config-permit-types)
                    :categories                  categories
                    :saved-categories            (<sub-dialog-data :saved-categories)
                    :tier                        (<sub-dialog-data :tier)})]
           [:div.my-6
            (cc/inline-loading {:description (tr [:admin/loading-permit-types])})])]

        (when (and (not= (top-bar/env-name) "prod")
                   (ff/enabled? :feature-flag.id/skip-config-creation-for-new-groups))
          [input-block
           [:h5.mb-2 (tr [:admin/skip-default-config-creation])]
           (cc/toggle {:id        "skip-default-config-creation"
                       :toggled   (boolean (<sub-dialog-data :skip-default-configuration?))
                       :labelA    (tr [:false])
                       :labelB    (tr [:true])
                       :on-toggle (edit-fn :skip-default-configuration?)})])


        (when (and upper-tier?
                   (seq (<sub-dialog-data :permit-types))
                   (empty? (<sub-dialog-data :municipalities)))
          [:div.font-bold
           (str "When a permit type is enabled for an upper-tier group, one or more (lower-tier) municipalities "
                "must also be added. If these already exist in the system, make sure to use the same municipality "
                "number and names.")])

        [municipality-list/municipality-list (assoc opts
                                                    :default-number (<sub-dialog-data :group-number)
                                                    :default-name (<sub-dialog-data :group-name)
                                                    :default-lang i18n-model/default-lang)]
        (when upper-tier?
          (let [groups (or (<sub-dialog-data :planning-lower-tier-ids) #{})]
            [:div.mt-4
             [:h5.mb-2 (tr [:admin/group-planning-groups])]
             [admin-common/member-group-editor {:tr                tr
                                                :groups            (<sub [::lower-tier-planning-groups])
                                                :current-group-ids groups
                                                :add-title         :admin/add-planning-group
                                                :save-fn           #(>evt [::admin-subs/dialog-edit
                                                                           :new-municipality
                                                                           :planning-lower-tier-ids
                                                                           (conj groups %)])
                                                :remove-fn         #(>evt [::admin-subs/dialog-edit
                                                                           :new-municipality
                                                                           :planning-lower-tier-ids
                                                                           (disj groups %)])}]]))]])))

(defn new-group-modal-body [opts]
  (let [edit-fn   (fn [k]
                    (fn [v]
                      (rf/dispatch-sync [::admin-subs/dialog-edit :new-municipality k (if (boolean? v) v (futil/tval v))])))
        disabled? (boolean (<sub-dialog-data :disabled?))
        editing?  (-> (<sub-dialog-data :edit-group-id) some?)
        opts      (-> opts
                      (assoc :disabled? disabled?)
                      (assoc :editing? editing?)
                      (assoc :edit-fn edit-fn))]
    [new-multi-municipality-modal-body opts]))

(defn new-municipality-modal [{:keys [tr] :as options}]
  [dialog options {:key            :new-municipality
                   :focus-selector "input#new-municipality-name"
                   :body           new-group-modal-body
                   :title          (tr [:admin/new-municipality])}])


;; -------------------------
;; Municipality table UI
;; -------------------------


(defn authority-group-feature
  "Renders checkboxes for feature flags (per authority group)"
  [{:keys [groups title feature tr country]}]
  (let [main-feature        (group-model/sub-feature->main-feature feature)
        global-flags        (<sub [::ff/enabled-flags])
        mobile-app-safe?    #(or (every? global-flags group-model/mobile-app-safety-conditions)
                                 (contains? (<sub [::mobile-app-safe-group-ids]) %))
        groups-with-feature (->> groups
                                 (filter #(or (contains? (:group/features %) feature)
                                              (group-model/feature-available? % country feature))))]
    (when (seq groups-with-feature)
      [:div.w-full.lg:w-1-2.mt-4.px-2 {:data-cy title}
       [:div.font-semibold.mb-1 title]
       (when main-feature
         [:div.mb-1.text-xs.italic
          (tr [:group.feature.issue/requires-main]
              [(tr [main-feature])])])
       [:div
        (for-frag [group groups-with-feature
                   :let [feature?  (contains? (:group/features group) feature)
                         disabled? (or (and (= feature :group.feature/mobile-app)
                                            (not (mobile-app-safe? (:db/id group))))
                                       (not (group-model/can-configure-feature? group
                                                                                global-flags
                                                                                feature
                                                                                (not feature?))))]]
          [:div {:key (str (:db/id group) "-" feature "-row")}
           [:div (cc/checkbox (merge
                                {:id         (str (:db/id group) feature)
                                 :label-text (:group/name group)
                                 :checked    feature?
                                 :disabled   disabled?
                                 :on-change  #(>evt [::toggle-feature
                                                     (:db/id group)
                                                     feature
                                                     (:group/features group)
                                                     (not feature?)
                                                     (:entity/version group)])}
                                (when-let [issue (and disabled?
                                                      (group-model/configure-feature-issue group
                                                                                           global-flags
                                                                                           feature
                                                                                           (not feature?)))]
                                  {:title (tr [issue])})))]])]])))

(defn domain-group-feature [{:keys [tr group feature country]}]
  (when (or (contains? (:group/features group) feature)
            (group-model/feature-available? group country feature))
    (let [feature?     (contains? (:group/features group) feature)
          global-flags (<sub [::ff/enabled-flags])
          disabled?    (not (group-model/can-configure-feature? group
                                                                global-flags
                                                                feature
                                                                (not feature?)))]
      [:div {:key (str (:db/id group) "-" feature "-row")}
       (cc/checkbox (merge
                      {:id         (str (:db/id group) feature)
                       :label-text (tr [feature])
                       :checked    feature?
                       :disabled   disabled?
                       :on-change  #(>evt [::toggle-feature
                                           (:db/id group)
                                           feature
                                           (:group/features group)
                                           (not feature?)
                                           (:entity/version group)])}
                      (when-let [issue (and disabled?
                                            (group-model/configure-feature-issue group
                                                                                 global-flags
                                                                                 feature
                                                                                 (not feature?)))]
                        {:title (tr [issue])})))])))

(rf/reg-sub ::domain-features
  :<- [:tr]
  :<- [::ff/enabled? :feature-flag.id/custom-branding]
  :<- [::ff/enabled? :feature-flag.id/ai-settings-controls]
  (fn [[tr custom-branding-enabled? ai-settings-controls?] _]
    (->> group-model/domain-group-features-for-admin
         (remove #(or (and (= % :group.feature/custom-branding) custom-branding-enabled?)
                      (and (= % :group.feature/disable-ai) ai-settings-controls?)))
         (sort-by #(tr [%])))))

(rf/reg-sub ::authority-features
  :<- [:tr]
  (fn [tr _]
    (->> group-model/group-features-for-admin
         (sort-by #(tr [%])))))

(defn municipality-details [{:keys [tr]} domain-entity-id]
  (let [domain-group          (<sub [::entities/entity domain-entity-id])
        groups                (->> domain-group
                                   group-model/descendant-authority-groups
                                   (sort-by :group/name))
        scopes                (mapcat group-model/scopes groups)
        country               (->> scopes
                                   (map :scope/municipality)
                                   (some :municipality/country))
        domain-feats          (<sub [::domain-features])
        user-management-route (<sub [::gas/user-management-route])]
    [:div {:data-cy (:group/name domain-group)}
     [:div.flex
      [:div.w-1-2.px-2
       [:div.bx--label (tr [:admin/municipality-sub-groups])]
       (for-frag [{:group/keys [id] :as group} groups]
         [:div
          (cc/link {:href       (href/href :view/admin-groups
                                           {:group-id (:db/id group)})
                    :aria-label (str "Go to " (:group/name group))}
                   (str (:group/name group)
                        (when id
                          (str " (" (:group/id group) ")"))))])]
      [:div.w-1-2.pl-2.flex.justify-between
       [:div
        [:div.bx--label (tr [:admin/domain-group])]
        [:div
         (cc/link {:href       (href/href user-management-route
                                          {:group-id (:db/id domain-group)})
                   :aria-label (str (tr [:admin/domain-group-users]
                                        [(:group/name domain-group)]) " link")}
                  (tr [:admin/domain-group-users]
                      [(:group/name domain-group)]))]]
       [:div
        (if (seq scopes)
          [ui/modal-confirmation-button
           {:tr                  tr
            :modal-title         (tr [:admin/deactivate-group])
            :trigger-button-text (tr [:admin/deactivate-group])
            :trigger-button-opts {:size :small
                                  :kind :danger
                                  :icon i/remove}
            :disabled?           (<sub [:comm/command-processing? :admin/disable-domain-group])
            :on-yes-click        #(>evt [::disable-domain-group domain-entity-id])}
           (tr [:admin/deactivate-group-confirmation]
               [(:group/name domain-group)
                (:group/id domain-group)])]
          [:div.text-sm.font-bold.uppercase.text-red-600 (tr [:committee.state/inactive])])]]]
     (when (seq domain-feats)
       [:div.mt-4.ml-2.p-2.bg-ui-blue-10.rounded {:data-cy "domain-group-features-section"}
        [:h5.pl-2.mb-2 (tr [:admin/domain-group-features])]
        [:div.flex.flex-wrap.gap-y-2
         (for-frag [feature domain-feats]
           [:div.px-2.w-1-2
            [domain-group-feature {:group   domain-group
                                   :feature feature
                                   :country country
                                   :tr      tr}]])]])
     (when-let [authority-groups (->> groups
                                      (filter group-model/application-or-upper-tier-authority?))]
       (->> (<sub [::authority-features])
            (map (fn [feature]
                   [authority-group-feature {:groups  authority-groups
                                             :feature feature
                                             :country country
                                             :title   (tr [feature])
                                             :tr      tr}]))
            (into [:div.flex.flex-wrap])))]))


(defn domain-groups-table [{:keys [tr domains] :as options}]
  (r/with-let [*sorting (r/atom [:group/name false])]
    (if (seq domains)
      #_{:clj-kondo/ignore [:deprecated-var]}
      [ui-table/table {:tr tr :expandable? true :class "admin-municipality-table"}
       [[ui-table/table-header-sortable tr *sorting :group/name]
        [ui-table/table-header-sortable tr *sorting :group/id]
        [:th]]
       (let [[sort-key descending?] @*sorting
             groups-loading?        (boolean (<sub [::groups-loading?]))]
         (for-all [domain (->> domains
                               (sort-by sort-key (if descending? > <)))]
           {:key              (:db/id domain)
            :cols             [{:content (:group/name domain)}
                               {:content (:group/id domain)}
                               {:content
                                [:div.flex.items-center.justify-end
                                 (when groups-loading?
                                   (cc/inline-loading {}))
                                 (cc/button
                                   {:icon             i/pen
                                    :icon-description ""
                                    :size             :small
                                    :disabled         groups-loading?
                                    :on-click         #(>evt [::edit-municipality-open domain :lower-tier])}
                                   (tr [:edit]))]
                                :opts {:style {:width "150px"}}}]
            :expanded-content [municipality-details options (:db/id domain)]}))]
      (cc/inline-loading {:description (tr [:admin/municipality-groups-loading])}))))


(defn view [_]
  (let [tr      (<sub [:tr])
        domains (<sub [::lower-tier-domain-groups])]
    [:div.cloudpermit-page.admin-page
     [:div.bx--row.page-heading.justify-between
      [:h1 (tr [:admin-tools.municipality-groups])]
      (cc/button {:icon             i/plus
                  :icon-description (tr [:admin/add-municipality])
                  :on-click         #(>evt [::new-municipality-open :lower-tier])}
                 (tr [:admin/add-municipality]))]
     [:section.bx--row
      [domain-groups-table {:tr tr :domains domains}]]
     [new-municipality-modal {:tr tr :domains domains}]
     [:div.mt-6.w-full.justify-end.flex
      (cc/button
        {:href             "/api/command/admin/groups-municipalities-report"
         :icon             i/download
         :size             :field
         :class-name       "max-w-none"
         :icon-description ""}
        (tr [:reporting/download-report] ["XLSX"]))]]))


(def route
  {:name        :view/admin.municipality-groups
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::fetch-municipalities])
                           (>evt [::fetch-mobile-app-safe-group-ids]))}]})
